<template>
  <div class="ruejai-club-package-selector-option" :class="classList">
    <button class="select-button" @click="handleClickSelectButton">
      <img class="icon" :src="thumbnailUrl" />
      <div class="meta">
        <h4 class="name">{{ name }}</h4>
        <p class="desc">{{ detail }}</p>
        <p class="type">{{ packageType }}</p>
      </div>
    </button>
    <div class="action" v-if="canRemove">
      <sc-button variant="clean" :icon="true" @click="handleClickRemoveButton">
        <img src="/static/icons/close-red.svg" />
      </sc-button>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import { ruejaiClubPackageType } from "@/lib/mapper";

export default {
  components: {
    ScButton
  },
  props: [
    "name",
    "detail",
    "type",
    "thumbnailUrl",
    "canSelect",
    "canRemove"
  ],
  computed: {
    classList() {
      return { selectable: this.canSelect };
    },
    packageType() {
      const type = this.type === ruejaiClubPackageType.SALES_PACKAGE ? "Sale Package" : "Voucher Package";

      return type;
    }
  },
  methods: {
    handleClickSelectButton() {
      this.$emit("select");
    },
    handleClickRemoveButton() {
      this.$emit("remove");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 48px;
$padding: 10px ($space / 2);

.ruejai-club-package-selector-option {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;

  padding: $padding;

  font-family: "Sukhumvit Tadmai";

  > .select-button {
    cursor: default;
    user-select: text;
  }

  &.selectable {
    padding: 0;

    > .select-button {
      padding: $padding;
      cursor: pointer;
    }

    &:hover {
      background: #efefef;
    }
  }

  > .action {
    align-self: center;
  }
}

.select-button {
  display: flex;
  flex-flow: row nowrap;

  border: 0;
  padding: 0;
  outline: 0;
  min-width: 0;

  background: transparent;

  > .icon {
    margin-top: 5px;

    flex: 0 0 $logoSize;
  }

  > .meta {
    padding-left: 20px;
    display: block;

    flex-grow: 1;

    &:not(:last-child) {
      padding-right: 20px;
    }
  }
}

.icon {
  display: block;

  border-radius: 8px;
  width: $logoSize;
  height: $logoSize;
}

.meta {
  min-width: 0;

  > .desc {
    overflow: hidden;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > .type {
    overflow: hidden;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.meta .name {
  margin: 0;
  font-size: 0.9rem;
}

.meta p {
  font-size: 0.8rem;
  color: #777;
}

.meta .name,
.meta p {
  text-align: left;
  line-height: 1.6;
}

.title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  > .provider {
    padding-left: 15px;
  }
}

.provider {
  margin-top: 3px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .logo {
    margin-right: 8px;

    border-radius: $border-radius;
    width: 20px;
    height: 20px;
  }

  > .name {
    font-size: 0.8rem;
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/components/RuejaiClubPackageSelector/RuejaiClubPackageSelectorOption.vue